//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useCallback, useEffect, useState } from "react";
import { useSessionStorage } from "@uidotdev/usehooks";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import moment from "moment";
import Card from "../Reusable/Card";
import { IFilterReport } from "../../types/interface";
import Filter from "./Filter";
import { useSearchParams } from "react-router-dom";
import DataTable from "../Reusable/AttendanceDatatable";
import NACell from "../Reusable/AttendanceDatatable/NACell";

const AttendanceReportList = (props: any) => {
  const [localState, handleSetState] = useSessionStorage<IFilterReport>(
    "attendance-report-filter",
    {
      created__range: null,
      name: null,
    }
  );
  const [searchParams, setSearchParams] = useSearchParams();

  const attendanceColumns = [
    {
      header: "Date",
      accessorKey: "date",
      cell: ({ getValue }) => moment(getValue()).format("YYYY-MM-DD"),
    },
    {
      header: "Check In",
      accessorKey: "check_in_time",
      cell: ({ getValue }) =>
        getValue() ? moment(getValue()).format("HH:mm") : "N/A",
    },
    {
      header: "Check Out",
      accessorKey: "check_out_time",
      cell: ({ getValue }) =>
        getValue() ? moment(getValue()).format("HH:mm") : "N/A",
    },

    {
      header: "CheckIn/Out Map",
      accessorKey: "location",
      cell: ({ row }: any) => {
        const loc = row.original.location || "N/A";
        const checkInLat = row.original.check_in_latitude;
        const checkInLng = row.original.check_in_longitude;
        const checkOutLat = row.original.check_out_latitude;
        const checkOutLng = row.original.check_out_longitude;

        return (
          <div className={tw`flex flex-col gap-1 items-start`}>
            <button
              type="button"
              disabled={!checkInLat || !checkInLng}
              onClick={() =>
                window.open(
                  `https://www.google.com/maps?q=${checkInLat},${checkInLng}`,
                  "_blank"
                )
              }
              className={tw`text-blue-600 focus:outline-none`}
            >
              Check In
            </button>

            <button
              type="button"
              disabled={!checkOutLat || !checkOutLng}
              onClick={() =>
                window.open(
                  `https://www.google.com/maps?q=${checkOutLat},${checkOutLng}`,
                  "_blank"
                )
              }
              className={tw`text-green-600 focus:outline-none`}
            >
              Check Out
            </button>
          </div>
        );
      },
    },
    {
      header: "Type",
      accessorKey: "attendance_type",
      cell: NACell,
    },
    {
      header: "Marked By",
      accessorKey: "marked_by",
      cell: NACell,
    },
    {
      header: "Within Geo-Fence",
      accessorKey: "is_within_geofence",
      cell: ({ getValue }) => {
        const val = getValue();
        return (
          <span className={tw`${val ? "text-green-700 font-bold": "text-red-700 font-bold"}`}>
            {val ? "Yes": "No"}
          </span>
        );
    },
    },
  ]
  const handleFilterReset = () => {
    reset({
      created__range: null,
      name: null,
    });
  };
  const { setValue, getValues, watch, reset, control, clearErrors } =
    useForm<IFilterReport>({
      defaultValues: async () => {
        return {
          created__range: localState?.created__range ?? null,
          name: localState?.name ?? null,
        };
      },
    });

  const filterParams = watch();
  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]);
  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  const dateRange = getValues("created__range")?.split(",") || [];
  const formattedRange = dateRange.map((d) => d.split("T")[0]).join(",");

  return (
    <>
      <Card title="Filter Report">
        <Filter
          control={control}
          reset={handleFilterReset}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </Card>
      
      {filterParams.name && (
        <DataTable
          url={`${APIS.ATTENDANCE_REPORT}`}
          queryKey={"attendance"}
          columns={attendanceColumns}
          tableName={"attendance-reports-list"}
          params={{
            ...params(),
          }}
        />
      )}
    </>
  );
};

export default AttendanceReportList;
